/** 바로고 공지사항 */
export default class BarogoNotice {
    _id = '';
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    _title = '';
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    _body = '';
    get body() {
        return this._body;
    }
    set body(value) {
        this._body = value;
    }
    _createdAt = 0;
    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    constructor(_data) {
        if (!_data) {
            return;
        }
        const data = this.translate(_data);
        Object.assign(this, data);
    }
    /**
     * 서버 응답값을 프론트에서 사용할 형태로 번역
     * back -> front
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    translate(data) {
        return {
            ...data,
        };
    }
}
